'use client';

import { c as _c } from "react/compiler-runtime";
import type { AnswerState } from '@repo/contracts/cardfinder/funnel/types';
import { useParams } from 'next/navigation';
import { createContext, type MutableRefObject, type ReactNode, useMemo, useReducer, useRef } from 'react';
import { getBranchId } from '../../config/utils/client';
import type { SessionSyncResult } from '../sessionWriteResult';
import type { AnswerAction } from './actions';
import { initialAnswerStore, reducer } from './reducer';
import { useAnswerSubmissionSync } from './session/useAnswerSubmissionSync';
import type { AnswerStore } from './types';
type AnswerContextValue = {
  store: AnswerStore;
  dispatch: React.Dispatch<AnswerAction>;
  persistSubmittedAnswer: (submittedAnswers: AnswerState, funnelConfigVersion: string) => Promise<SessionSyncResult>;
  // Shared with useFunnelSessionSync (called from FunnelProvider), so the two
  // catch-up guards agree on whether the login backlog is already covered.
  hasSyncedOnLoginRef: MutableRefObject<boolean>;
};
export const AnswerContext = createContext<AnswerContextValue | undefined>(undefined);
export function AnswerProvider(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const params = useParams();
  const branchSlug = params.branch;
  let t1;
  if ($[0] !== branchSlug) {
    t1 = typeof branchSlug === "string" ? getBranchId(branchSlug) : null;
    $[0] = branchSlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const branchId = t1;
  const [store, dispatch] = useReducer(reducer, initialAnswerStore);
  const hasSyncedOnLoginRef = useRef(false);
  let t2;
  if ($[2] !== branchId || $[3] !== store) {
    t2 = {
      branchId,
      store,
      dispatch,
      hasSyncedOnLoginRef
    };
    $[2] = branchId;
    $[3] = store;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    persistSubmittedAnswer
  } = useAnswerSubmissionSync(t2);
  let t3;
  if ($[5] !== persistSubmittedAnswer || $[6] !== store) {
    t3 = {
      store,
      dispatch,
      persistSubmittedAnswer,
      hasSyncedOnLoginRef
    };
    $[5] = persistSubmittedAnswer;
    $[6] = store;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const value = t3;
  let t4;
  if ($[8] !== children || $[9] !== value) {
    t4 = <AnswerContext.Provider value={value}>{children}</AnswerContext.Provider>;
    $[8] = children;
    $[9] = value;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}